/**
 * Mockup script pro zobrazování obsahu na základě radio / checkbox inputů, včetně nastavování aria atributů. Ve Vue.js
 * bude přímo součástí komponenty, která prvky vypisuje (např. komponenta analogická s `RadioToggle.latte`). Jednotlivé
 * class a atributy mohou být přímo reaktivně v závislosti na stavu, tento JS pak bude zbytečný.
 */
const formBoolToggles = document.querySelectorAll('.js-form-bool-toggle')

type FormBoolToggleItem = {
	item: HTMLElement
	input: HTMLInputElement
	content: HTMLElement
	reset: HTMLElement | null
}

formBoolToggles.forEach((formBoolToggle) => {
	const items: FormBoolToggleItem[] = []

	formBoolToggle.querySelectorAll<HTMLElement>('.js-form-bool-toggle__item').forEach((item: HTMLElement) => {
		items.push({
			item,
			input: item.querySelector<HTMLInputElement>('.js-form-bool-toggle__input') as HTMLInputElement,
			content: item.querySelector<HTMLElement>('.js-form-bool-toggle__content') as HTMLElement,
			reset: item.querySelector<HTMLElement>('.js-form-bool-toggle__reset')
		})
	})

	formBoolToggle.addEventListener('toggle', () => {
		let activeItem: HTMLElement | null = null

		items.forEach((item: FormBoolToggleItem) => {
			const checked = item.input.checked

			if (checked) {
				activeItem = item.item
			}

			item.input.setAttribute('aria-expanded', checked.toString())

			item.item.classList.toggle('js-form-bool-toggle__item--active', checked)
			item.reset?.classList.toggle('opacity-0', !checked)
			item.reset?.classList.toggle('pointer-events-none', !checked)

			if (checked) {
				item.reset?.removeAttribute('tabindex')
			} else {
				item.reset?.setAttribute('tabindex', '-1')
			}
		})

		if (activeItem) {
			;(activeItem as HTMLElement).scrollIntoView({
				block: 'nearest'
			})
		}
	})

	formBoolToggle.dispatchEvent(new Event('toggle'))

	items.forEach((item: FormBoolToggleItem) => {
		item.input.addEventListener('change', () => {
			formBoolToggle.dispatchEvent(new Event('toggle'))
		})

		item.reset?.addEventListener('click', () => {
			if (item.input) {
				item.input.checked = false
				item.input.dispatchEvent(new Event('change'))
			}
		})
	})
})
